import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import Divider from '@mui/material/Divider';
import styled from '@emotion/styled';

import { BREAKPOINTS } from '../../constants';
import VariantFilter from '../vehicle-variant-filter';
import VehicleVariantList from '../vehicle-variant-list';

const StyledDivider = styled(Divider)`
  margin-bottom: 1rem;
  margin-top: 1rem;

  @media (min-width: ${BREAKPOINTS.MD}px) {
    margin-top: 0;
  }

  &.MuiDivider-root {
    border-width: 1px;
  }
`;

// @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'filters' implicitly has an 'any' type.
const DynamicVariantFilters = ({ filters, allVehicles, onChange, isFullWidth = false }) => {
  return (
    <>
      {_.map(filters, ({ label, options, selectedOption }, index) => {
        const props = {
          label,
          options,
          allVehicles,
          selectedOption,
          // @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'event' implicitly has an 'any' type.
          onChange: (event, item) => onChange({ ...event, filterLabel: label }, item, index),
        };
        return label === 'Vehicle Description' ? (
          <>
            {filters.length > 1 && <StyledDivider />}
            {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: Type '{ label: any; options: any; allVehicles: any; selectedOption: any; onChange: (event: any, item: any) => any; }' is not assignable to type 'VehicleVariantListProps'. */}
            <VehicleVariantList {...props} />
          </>
        ) : (
          <VariantFilter {...props} isFullWidth={isFullWidth} />
        );
      })}
    </>
  );
};

DynamicVariantFilters.propTypes = {
  filters: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      options: PropTypes.array,
    })
  ),
  onChange: PropTypes.func.isRequired,
  isFullWidth: PropTypes.bool,
};

export default DynamicVariantFilters;
